import Vue from 'vue';
import Vuex from 'vuex';
import users from "./users";
import customer from "./customer";
import applications from "./applications";
import loans from "./loans";
import cards from "./cards";
import transactions from "./transactions";
import holidays from "./holidays";
import flags from "./flags";
import cookiebot from "./cookiebot";
Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function /* { ssrContext } */
() {
  var Store = new Vuex.Store({
    modules: {
      users: users,
      customer: customer,
      applications: applications,
      loans: loans,
      cards: cards,
      transactions: transactions,
      holidays: holidays,
      flags: flags,
      cookiebot: cookiebot
    },
    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: false
  });
  return Store;
}